// @ts-nocheck

import lottie_vuzcheck from '@shared/assets/lottie/lottie_vuzcheck.json';
import lottie_download from '@shared/assets/lottie/lottie_download.json';
import lottie_phone from '@shared/assets/lottie/lottie_phone.json';
import lottie from 'lottie-web';
import React, { useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { isAE, isMY, isOM } from '@entities/country/model/utils';
import RoundLoader from '@shared/ui/round-loader/ui/RoundLoader';
import { ImageList } from '@shared/config/constants/Images';
import { useAtomValue } from 'jotai';
import { dcbAtom } from '@shared/store/slice-atoms';
import {
  V5_CHECKMARK_TRIAL,
  V5_DOWNLOAD_ICON_TRIAL,
} from '@shared/config/constants/api-sources';
import { useCheckMarkLYCondition } from '@features/phone-subscription/model/hooks/useCheckMarkLYCondition';

const URL_REFERRER_SS_NAME = 'urlReferrer';

const LottiePlayer = ({ animationData, height = 185, width = 185 }) => {
  const containerRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !animationData) {
      return undefined;
    }

    animationRef.current = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    });

    return () => {
      if (animationRef.current) {
        animationRef.current.destroy();
        animationRef.current = null;
      }
    };
  }, [animationData]);

  return <div ref={containerRef} style={{ height, width }} />;
};

export const LottieAnimation = () => {
  const { t } = useTranslation();

  const dcb = useAtomValue(dcbAtom);
  const homeData = dcb.homeData;
  const operatorSelectedDetails = dcb.operatorSelectedDetails;
  const { isCheckMarkLY } = useCheckMarkLYCondition();
  const hadSourceRef = useRef(false);

  if (homeData.source) {
    hadSourceRef.current = true;
  }

  const operatorText =
    operatorSelectedDetails?.dailyText ||
    operatorSelectedDetails?.weeklyText ||
    operatorSelectedDetails?.monthlyText ||
    '';

  const SSUrlReferrer = sessionStorage.getItem(URL_REFERRER_SS_NAME);

  const partUrl = window.location.pathname && SSUrlReferrer ? SSUrlReferrer : null;

  const animationData = getAnimationDataByUrlPart(partUrl);

  const bannerTitle = getBannerTitleByUrlPart(partUrl);

  const isLottieHidden =
    (homeData.source === V5_CHECKMARK_TRIAL || homeData.source === V5_DOWNLOAD_ICON_TRIAL) &&
    isMY(homeData.country);

  if (!homeData.source && !hadSourceRef.current) {
    return <RoundLoader />;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
      {animationData && !isLottieHidden ? (
        <LottiePlayer animationData={animationData} height={185} width={185} />
      ) : null}

      {homeData.source === V5_CHECKMARK_TRIAL && isMY(homeData.country) ? (
        <img
          className="img-fluid banner-img"
          src={ImageList.check_mark_trial_banner}
          alt="banner"
        />
      ) : null}

      {homeData.source === V5_DOWNLOAD_ICON_TRIAL && isMY(homeData.country) ? (
        <img className="img-fluid banner-img" src={ImageList.watch_my_trial_banner} alt="banner" />
      ) : null}

      {bannerTitle && isAE(homeData?.country) ? (
        <p
          style={{
            margin: 0,
            fontSize: '10px',
            fontWeight: 'bold',
            textAlign: 'center',
            padding: '0 16px',
          }}
        >
          {t(bannerTitle)}
        </p>
      ) : null}

      {isCheckMarkLY ? (
        <p
          id="under-banner-text"
          style={{
            margin: 0,
            fontSize: '10px',
            fontWeight: 'bold',
            textAlign: 'center',
            padding: '0 16px',
          }}
        >
          {t('check_mark_ly_banner_subtitle')}
        </p>
      ) : null}

      {isOM(homeData.country) ? (
        <p
          style={{
            margin: 0,
            fontSize: '10px',
            fontWeight: 'bold',
            textAlign: 'center',
            padding: '0 16px',
          }}
        >
          {operatorText}
        </p>
      ) : null}
    </div>
  );
};

const getAnimationDataByUrlPart = (urlPart = null) => {
  const locationPath = urlPart || window.location.pathname;

  if (locationPath.includes('/check_mark')) {
    return lottie_vuzcheck;
  }

  if (locationPath.includes('/download_icon')) {
    return lottie_download;
  }

  if (locationPath.includes('/phone_icon')) {
    return lottie_phone;
  }

  return null;
};

const getBannerTitleByUrlPart = (urlPart = null) => {
  const locationPath = urlPart || window.location.pathname;

  if (locationPath.includes('/check_mark')) {
    return 'lottie_banner_title';
  }

  if (locationPath.includes('/download_icon')) {
    return 'lottie_banner_title';
  }

  if (locationPath.includes('/phone_icon')) {
    return 'lottie_banner_title';
  }

  return '';
};
